import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReportingToolUserSelectionComponent } from '../reporting-tool-user-selection/reporting-tool-user-selection.component';
import { PickerDirective } from '../../directives/picker.directive';
import { IUser } from '@shared/interfaces';
import { isArray } from 'lodash-es';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../current-project';

@Component({
    selector: 'reporting-tool-user-picker',
    templateUrl: './reporting-tool-user-picker.component.html',
    styleUrls: ['./reporting-tool-user-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReportingToolUserPickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ReportingToolUserPickerComponent extends PickerDirective {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @Input() maxLength: number;
    @Input() fullData: boolean;
    @Input() disableExternal: boolean;

    get singleValue(): ISimpleUser | IUser {
        return this.value as ISimpleUser | IUser;
    }

    get simpleUser(): ISimpleUser {
        return this.singleValue as ISimpleUser;
    }

    get user(): IUser {
        return this.singleValue as IUser;
    }

    get multipleValue(): Array<ISimpleUser | IUser> {
        return this.value as Array<ISimpleUser | IUser>;
    }

    get multipleSimpleUsers(): ISimpleUser[] {
        return this.multipleValue as ISimpleUser[];
    }

    removeValue(item: ISimpleUser) {
        this.value = (this.value as Array<ISimpleUser | IUser>).filter(e => e.id !== item.id);
        this.propagateChange(this.value);
    }

    openDialog() {
        if (IS_TRS_PROJECT) {
            this.dialog
                .open(ReportingToolUserSelectionComponent, {
                    position: { top: '50px' },
                    panelClass: 'custom-dialog',
                    data: { excluded: this.exclude, fullData: this.fullData, disableExternal: this.disableExternal }
                })
                .beforeClosed()
                .subscribe((e: ISimpleUser) => {
                    if (e) {
                        if (!this.multiple) {
                            this.value = e;
                            this.propagateChange(this.value);
                        } else {
                            if (this.value && !(this.value as ISimpleUser[]).some(i => i.id === e.id)) {
                                (this.value as ISimpleUser[]).push(e);
                                this.propagateChange(this.value);
                            } else if (!this.value) {
                                this.value = [e];
                                this.propagateChange(this.value);
                            }
                        }
                    }
                });
        }

        if (IS_PRODUCT_SAFETY_PROJECT) {
            this.dialog
                .open(ReportingToolUserSelectionComponent, {
                    position: { top: '50px' },
                    panelClass: 'custom-dialog',
                    data: {
                        excluded: this.exclude,
                        fullData: this.fullData,
                        disableExternal: this.disableExternal,
                        multiple: this.multiple
                    }
                })
                .beforeClosed()
                .subscribe((e: ISimpleUser[]) => {
                    if (e) {
                        if (!this.multiple) {
                            this.value = e;
                            this.propagateChange(this.value);
                        } else {
                            console.log(e);
                            const userToBeAdded = e.filter(
                                e => !(this.value as ISimpleUser[]).some(i => i.id === e.id)
                            );
                            if (this.value && userToBeAdded?.length > 0) {
                                (this.value as ISimpleUser[]).push(...userToBeAdded);
                                this.propagateChange(this.value);
                            } else if (!this.value) {
                                console.log(isArray(e));
                                this.value = isArray(e) ? e : [e];
                                this.propagateChange(this.value);
                            }
                        }
                    }
                });
        }
    }
}

export interface ISimpleUser {
    id: string;
    fullName: string;
    eMail: string;
}
